module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/modules/$.a-function.js
// module id = 22
// module chunks = 0